<template>

    <div style="position: relative">

        <div class="d-flex">

            <b-input-group>

                <transition mode="out-in" name="slide-fade">

                    <b-input-group v-if=" !selectedUser ">

                        <b-form-input
                            autocomplete="off"
                            aria-label="Search users in CareExchange"
                            :placeholder=" placeholderText "
                            v-model=" filter "
                            @input=" onSearch "
                            @focus=" showResults = true "
                            @blur=" hideResults() "
                        ></b-form-input>

                        <template v-slot:append>

                            <b-dropdown :text=" filterByText " variant="info" style="width: 95px">

                                <b-dropdown-item @click=" chooseFilter( 'name'   ) ">Name/Email</b-dropdown-item>
                                <b-dropdown-item @click=" chooseFilter( 'upd'    ) " v-if=" type == 'provider' ">UPD ID</b-dropdown-item>
                                <b-dropdown-item @click=" chooseFilter( 'agency' ) " v-if=" type == 'provider' ">Agency Name</b-dropdown-item>
                                <b-dropdown-item @click=" chooseFilter( 'policy' ) " v-if=" type == 'claimant' ">Policy Number</b-dropdown-item>
                            </b-dropdown>
                        </template>
                    </b-input-group>

                    <b-button variant="info" class="align-items-center d-flex justify-content-between w-100" v-else>{{ `${selectedUser.firstname} ${selectedUser.lastname}` }}<b-badge variant="light"><i class="fa fa-trash" @click=" removeUser() " v-if="!disabled"></i></b-badge></b-button>

                </transition>
            </b-input-group>
        </div>

        <div v-show=" showResults " class="search-results">

            <b-dropdown-item :disabled=" type == 'claimant' ">

                <div class="text-muted d-flex align-items-center justify-content-between">

                    <b-button v-if=" type == 'provider' " variant="default" @click.stop=" searchRotating() " class="f-1 text-left">RC</b-button>
                    <p class="mb-0 text-right">Showing {{ presentLoaded }} of {{ total }} results</p>
                </div>
            </b-dropdown-item>

            <b-dropdown-item v-for=" ( item, key ) in items " :key=" type + key + item.id " @click.stop=" selectUser( item ) ">

                {{ `${item.firstname} ${item.lastname}` }}
            </b-dropdown-item>

            <b-dropdown-item class="text-muted text-right" v-if=" items.length > 0 && total > presentLoaded " @click.stop=" loadMore() ">

                ..load more
            </b-dropdown-item>
        </div>
    </div>
</template>

<script>

    import ScopesToUser from '../mixins/ScopesToUser';

    export default {

        name: 'UserRoleSearchDropdown',

        props: [ 'type', 'value', 'userpreselect', 'placeholder', 'disabled' ],

        mixins: [ ScopesToUser ],

        data() {

            return {

                baseUrl      : `/search-role`,
                loading      : false,

                selectedUser : null,

                total        : 0,
                perPage      : 15,
                currentPage  : 1,

                items        : [],

                filterBy     : 'name',
                filter       : '',
                showResults  : false,
            };
        },

        computed: {

            placeholderText(){ return this.placeholder ? this.placeholder : `Search ${ _.capitalize( this.type ) }s`; },
            appliedFilters(){ return `?filter=${this.filter}&type=${this.type}&filterBy=${this.filterBy}`; },
            presentLoaded(){ return this.items.length; },
            paginationControls(){ return `&perPage=${this.perPage}&page=${this.currentPage}`; },
            filterByText(){ return this.filterBy.toUpperCase(); }
        },

        methods: {

            chooseFilter( value ){

                this.filterBy = value;
            },
            searchRotating(){

                this.filter = 'Rotating Caregiver-';
            },

            onSearch() {
                if (this.disabled) {
                    return;
                }

                if( this.filter != '' ) this.search( this );
            },

            loadMore(){

                this.currentPage++;
                this.search( this );
                this.showResults = true;
            },

            search: _.debounce( ( vm ) => {

                if( vm.selectedUser ) return;

                vm.loading = true;
                axios.get( `${vm.baseUrl}${vm.appliedFilters}${vm.paginationControls}&caregiver_id=${vm.caregiver_id}&client_id=${vm.client_id}` )
                    .then( response => {

                        vm.items   = response.data.data.results || [];
                        vm.total   = response.data.data.total || 0;
                        vm.loading = false;
                    })
                    .catch( e => {

                        vm.showResults = false;
                        vm.items       = [];
                        vm.total       = 0;
                        vm.loading     = false;
                    })
                    .finally( () => vm.loading = false );
            }, 350 ),

            selectUser( user ){

                this.selectedUser = user;
                this.$emit( 'input', user.id );
                this.$emit( 'user', user);
            },
            removeUser(){
                if (this.disabled) {
                    return;
                }

                this.selectedUser = null;
                this.$emit( 'input', '' );
                this.$emit( 'user', null);
            },
            hideResults() {

                setTimeout( function() {

                    this.showResults = false;
                }.bind( this ), 200 );
            },
        },

        created(){

            if( this.userpreselect && this.userpreselect.id ) this.selectUser( this.userpreselect );
        },
        mounted(){

            this.search( this );
        },

        watch: {

            appliedFilters(){

                if( !this.loading ){

                    this.currentPage = 1;
                    this.search( this );
                    this.showResults = true;
                }
            }
        },
    }
</script>

<style scoped>

</style>